/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {currentPageSelector} from '@/store/selectors/nav-selectors';
import SideSheetTrackingContent from '../routes/tracking/SideSheetTrackingContent';

interface SideSheetContentProps {
  toggleSideSheet?: Function;
}

// [ION-APP TODO] Link Components for each sideSheet here
// **NOTE - Placeholder Component
const SideSheetDashboardContent = () => (
  <div>Dashboard SideSheet</div>
);

// **NOTE - Placeholder Component
const SideSheetIssuesContent = () => (
  <div>Issues SideSheet</div>
);

// **NOTE - Placeholder Component
const SideSheetReportsContent = () => (
  <div>Reports SideSheet</div>
);

// **NOTE - Placeholder Component
const SideSheetMaintenanceContent = () => (
  <div>Maintenance SideSheet</div>
);

/**
 * Provides the mapping of ION page navigation items to their respective
 * SideSheet Components.
 */
const sideSheetContentMap = {
  dashboard   : SideSheetDashboardContent,
  tracking    : SideSheetTrackingContent,
  issues      : SideSheetIssuesContent,
  reports     : SideSheetReportsContent,
  maintenance : SideSheetMaintenanceContent
};

/**
 * @SideSheetContent
 *
 * The SideSheetContent component provides a map of the content
 * that would live in a side sheet per page
 */
export const SideSheetContent = ({toggleSideSheet}: SideSheetContentProps) => {
  const currentPage = useSelector(currentPageSelector);
  const page        = currentPage?.replace('/', '').split('?')[0];
  const Content     = sideSheetContentMap[page];

  return (Content ? (
    <Content toggleSideSheet={toggleSideSheet} />
  ) : null);
};

export default memo(SideSheetContent);
